import { NgClass, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, EventEmitter, Output, Input, ViewChildren, Optional, Inject, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import * as i4 from '@aposin/ng-aquila/icon';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/a11y';
const _c0 = ["link"];
const _forTrack0 = ($index, $item) => $item.value;
function NxPaginationComponent_Conditional_0_For_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_For_11_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const pageNum_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPage(pageNum_r4.value));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageNum_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.getPaginationNumberClasses(pageNum_r4));
    i0.ɵɵattribute("aria-current", pageNum_r4.value === ctx_r1.page ? "page" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", pageNum_r4.label, " ");
  }
}
function NxPaginationComponent_Conditional_0_For_11_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageNum_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", pageNum_r4.label, " ");
  }
}
function NxPaginationComponent_Conditional_0_For_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtemplate(1, NxPaginationComponent_Conditional_0_For_11_Conditional_1_Template, 3, 3, "button", 15)(2, NxPaginationComponent_Conditional_0_For_11_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageNum_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.getPaginationItemClasses(pageNum_r4));
    i0.ɵɵadvance();
    i0.ɵɵconditional(pageNum_r4.label !== "..." ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(pageNum_r4.label === "..." ? 2 : -1);
  }
}
function NxPaginationComponent_Conditional_0_For_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11)(1, "button", 16, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_For_13_Template_button_click_1_listener() {
      const pageNum_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPage(pageNum_r6.value));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const pageNum_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.getPaginationItemClasses(pageNum_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.getPaginationNumberClasses(pageNum_r6));
    i0.ɵɵattribute("aria-current", pageNum_r6.value === ctx_r1.page ? "page" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", pageNum_r6.label, " ");
  }
}
function NxPaginationComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 1)(1, "ul", 4)(2, "li", 5)(3, "button", 6, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFirst());
    });
    i0.ɵɵelement(5, "nx-icon", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "li", 8)(7, "button", 9, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPrev());
    });
    i0.ɵɵelement(9, "nx-icon", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵrepeaterCreate(10, NxPaginationComponent_Conditional_0_For_11_Template, 3, 3, "li", 10, _forTrack0);
    i0.ɵɵrepeaterCreate(12, NxPaginationComponent_Conditional_0_For_13_Template, 4, 4, "li", 11, _forTrack0);
    i0.ɵɵelementStart(14, "li", 12)(15, "button", 13, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNext());
    });
    i0.ɵɵelement(17, "nx-icon", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "li", 5)(19, "button", 14, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_0_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLast());
    });
    i0.ɵɵelement(21, "nx-icon", 7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.first);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-last" : "arrow-first");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.previous);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-right" : "arrow-left");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.getPages());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.getMobilePages());
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.next);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-left" : "arrow-right");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.last);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-first" : "arrow-last");
  }
}
function NxPaginationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 2)(1, "button", 17, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPrev());
    });
    i0.ɵɵelement(3, "nx-icon", 7);
    i0.ɵɵelementStart(4, "span", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 19)(7, "span", 20);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 22);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "button", 23, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_1_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNext());
    });
    i0.ɵɵelementStart(15, "span", 18);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "nx-icon", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationPreviousDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.previous);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-right" : "arrow-left");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.paginationTexts.previous, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.page);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.paginationTexts.ofLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.totalNumberPages);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationNextDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.next);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.paginationTexts.next, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-left" : "arrow-right");
  }
}
function NxPaginationComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "button", 24, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_2_For_7_Template_button_click_1_listener() {
      const pageNum_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPage(pageNum_r10.value));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const pageNum_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-active", pageNum_r10.value === ctx_r1.page);
    i0.ɵɵattribute("aria-label", pageNum_r10.value)("aria-current", pageNum_r10.value === ctx_r1.page ? "page" : "");
  }
}
function NxPaginationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 3)(1, "ul", 4)(2, "li", 8)(3, "button", 9, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPrev());
    });
    i0.ɵɵelement(5, "nx-icon", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵrepeaterCreate(6, NxPaginationComponent_Conditional_2_For_7_Template, 3, 4, "li", 5, _forTrack0);
    i0.ɵɵelementStart(8, "li", 12)(9, "button", 13, 0);
    i0.ɵɵlistener("click", function NxPaginationComponent_Conditional_2_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNext());
    });
    i0.ɵɵelement(11, "nx-icon", 7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationSliderPreviousDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationSliderPreviousDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.previous);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-right" : "arrow-left");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.getSlides());
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-disabled", ctx_r1._isPaginationSliderNextDisabled());
    i0.ɵɵproperty("disabled", ctx_r1._isPaginationSliderNextDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.paginationTexts.next);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1._isRTL ? "arrow-left" : "arrow-right");
  }
}
const DefaultPaginationTexts = {
  previous: 'Previous',
  next: 'Next',
  first: 'First',
  last: 'Last',
  ofLabel: 'of',
  ariaLabel: 'Please select your page'
};
/** InjectionToken for pagination that can be used to override default locale code. */
const NX_PAGINATION_TEXTS = new InjectionToken('nx-pagination-texts');

/** @docs-private */
class NxPaginationUtils {
  constructor() {
    this._pagesMobile = 3;
    this._elipsisText = '...';
    this._classExpanded = 'expanded-view';
  }
  getSlides(totalSlides) {
    return Array.from(Array(totalSlides).keys()).map(item => this.createPaginationItem(item + 1, item + 1));
  }
  getPages(currentPage, totalPages) {
    let pages = [];
    let start = [],
      middle = [],
      end = [];
    // First array -> start
    start = this.getStartArray(currentPage, totalPages);
    // Second array -> middle
    middle = this.getMiddleArray(currentPage, totalPages);
    // Third array -> end
    end = this.getEndArray(currentPage, totalPages);
    pages = [...start, ...middle, ...end];
    return pages;
  }
  getMiddleArray(currentPage, totalPages) {
    let pageNumber = currentPage < 6 ? 4 : currentPage - 1;
    const middle = [];
    while (middle.length < 3 && pageNumber >= 2 && pageNumber <= totalPages - 3 && pageNumber <= currentPage + 1 && pageNumber >= currentPage - 1) {
      middle.push(this.createPaginationItem(pageNumber, pageNumber));
      pageNumber++;
    }
    return middle;
  }
  getEndArray(currentPage, totalPages) {
    const end = [];
    let currentItemToShow = totalPages <= 3 ? totalPages + 1 : totalPages <= 6 ? totalPages - (totalPages - 4) : totalPages - 2;
    const showEllipsis = currentPage < totalPages - 4;
    while (currentItemToShow <= totalPages) {
      const endItem = end.length === 0 && showEllipsis ? this.createPaginationItem(this._elipsisText, currentItemToShow, true) : this.createPaginationItem(currentItemToShow, currentItemToShow, true);
      end.push(endItem);
      currentItemToShow++;
    }
    return end;
  }
  getStartArray(currentPage, totalPages) {
    let counterPages = 0;
    const start = [];
    const maxSizeArray = 3;
    while (counterPages < maxSizeArray && counterPages < totalPages) {
      const startItem = counterPages === 2 && currentPage > 5 ? this.createPaginationItem(this._elipsisText, counterPages + 1, true) : this.createPaginationItem(counterPages + 1, counterPages + 1, true);
      start.push(startItem);
      counterPages++;
    }
    return start;
  }
  getMobilePages(currentPage, totalPages) {
    // if we have less pages than the number we want to display take all
    if (totalPages < this._pagesMobile) {
      return Array.from(Array(totalPages).keys()).map(item => this.createPaginationItem(item + 1, item + 1));
    }
    switch (currentPage) {
      // first page active
      case 1:
        return [1, 2, 3].map(item => this.createPaginationItem(item, item));
      // last page active
      case totalPages:
        return [totalPages - 2, totalPages - 1, totalPages].map(item => this.createPaginationItem(item, item));
      // any other page active
      default:
        return [currentPage - 1, currentPage, currentPage + 1].map(item => this.createPaginationItem(item, item));
    }
  }
  createPaginationItem(label, value, classExpanded) {
    return {
      label,
      value,
      class: classExpanded ? this._classExpanded : ''
    };
  }
  static {
    this.ɵfac = function NxPaginationUtils_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPaginationUtils)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxPaginationUtils,
      factory: NxPaginationUtils.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPaginationUtils, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class NxPaginationComponent {
  /** Sets the aria label on the nav element of the pagination. Use this to override the global aria-label from PaginationTexts. */
  set ariaLabel(value) {
    this._ariaLabel = value;
  }
  get ariaLabel() {
    return this._ariaLabel || this.paginationTexts.ariaLabel;
  }
  /** Sets the current page. */
  set page(value) {
    this._page = value;
    this._cdr.markForCheck();
  }
  get page() {
    return this._page;
  }
  /** Number of total items over all pages. */
  set count(value) {
    this._count = value;
    this.totalNumberPages = this.calculateTotalPages();
    this._cdr.markForCheck();
  }
  get count() {
    return this._count;
  }
  /** Sets the number of items you want to show per page. */
  set perPage(value) {
    this._perPage = value;
    this.totalNumberPages = this.calculateTotalPages();
    this._cdr.markForCheck();
  }
  get perPage() {
    return this._perPage;
  }
  /**
   * Determines the type of pagination.
   *
   * Values: simple | advanced | slider, default: simple.
   */
  set type(value) {
    // type advanced or simple
    this._type = value;
    this._cdr.markForCheck();
  }
  get type() {
    return this._type;
  }
  constructor(paginationTexts, _dir, paginationUtilsService, _cdr, _focusMonitor) {
    this._dir = _dir;
    this.paginationUtilsService = paginationUtilsService;
    this._cdr = _cdr;
    this._focusMonitor = _focusMonitor;
    /** @docs-private */
    this.totalNumberPages = 0;
    this._ariaLabel = '';
    this._type = 'simple';
    /** An event emitted when the previous page button is clicked. */
    this.goPrev = new EventEmitter();
    /** An event emitted when the next page button is clicked */
    this.goNext = new EventEmitter();
    /**
     * An event emitted when a page number is clicked.
     * Provides the number of the page as parameter.
     */
    this.goPage = new EventEmitter();
    this._destroyed = new Subject();
    this.paginationTexts = paginationTexts || DefaultPaginationTexts;
    this._dir?.change.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this._cdr.detectChanges();
    });
  }
  ngOnInit() {
    this.totalNumberPages = this.calculateTotalPages();
  }
  ngAfterContentInit() {
    if (this.type === 'advanced' && (!this.paginationTexts.last || !this.paginationTexts.first)) {
      console.warn('Please define aria labels for the last and first arrows.');
    }
  }
  ngAfterViewInit() {
    this._linkElements.forEach(link => this._focusMonitor.monitor(link));
    this._linkElementsPrevious = this._linkElements;
    this._linkElements.changes.subscribe(_linkElements => {
      this._linkElementsPrevious = this._linkElements;
      this._linkElements.forEach(link => this._focusMonitor.monitor(link));
    });
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this._linkElements?.forEach(link => this._focusMonitor.stopMonitoring(link));
  }
  /** Returns the number of the first page. */
  getMin() {
    return this.totalNumberPages > 0 ? 1 : 0;
  }
  /** Returns the number of the last page. */
  getMax() {
    let max = this._perPage * this._page;
    if (max > this._count) {
      max = this._count;
    }
    return max;
  }
  /** Returns the total number of pages */
  calculateTotalPages() {
    return Math.ceil(this._count / this._perPage) || 0;
  }
  /** Directs to the page with number n. */
  onPage(n) {
    this.goPage.emit(n);
  }
  /** Directs to the previous page. */
  onPrev() {
    if (!this._isPaginationPreviousDisabled()) {
      this.goPrev.emit();
    }
  }
  /** Directs to the next page. */
  onNext() {
    if (!this._isPaginationNextDisabled()) {
      this.goNext.emit();
    }
  }
  /** Directs to the first page. */
  onFirst() {
    if (!this._isPaginationPreviousDisabled()) {
      this.onPage(1);
    }
  }
  /** Directs to the last page. */
  onLast() {
    if (!this._isPaginationNextDisabled()) {
      this.onPage(this.totalNumberPages);
    }
  }
  /** Returns if the current page is the last page. */
  lastPage() {
    return this._perPage * this._page >= this._count;
  }
  /** @docs-private */
  getSlides() {
    return this.paginationUtilsService.getSlides(this._count);
  }
  /** @docs-private */
  getPages() {
    return this.paginationUtilsService.getPages(this._page, this.totalNumberPages);
  }
  /** @docs-private */
  getMobilePages() {
    return this.paginationUtilsService.getMobilePages(this._page, this.totalNumberPages);
  }
  /** @docs-private */
  getPaginationItemClasses(page) {
    const classes = {
      'is-ellipsis': page.label === '...',
      'nx-pagination__item--expanded-view': page.class === 'expanded-view'
    };
    return classes;
  }
  /** @docs-private */
  getPaginationNumberClasses(page) {
    const classes = {
      'is-active': page.value === this.page,
      'nx-pagination__ellipsis': page.label === '...',
      'nx-pagination__link': page.label !== '...'
    };
    return classes;
  }
  /** Returns true, if `nxCount` is greater than 0, else false. */
  isPaginationVisible() {
    return this.count > 0;
  }
  /** Returns true, if `nxCount` is greater than 0 and the type of pagination is 'simple', else false. */
  isPaginationCompactVisible() {
    return this.type.includes('simple') && this.count > 0;
  }
  /** Returns true, if `nxCount` is greater than 0 and the type of pagination is 'slider', else false. */
  isPaginationSliderVisible() {
    return this.type.includes('slider') && this.count > 0;
  }
  /** @docs-private */
  isPaginationContainerVisible() {
    return this.type.includes('advanced');
  }
  _isPaginationPreviousDisabled() {
    return this.page === this.getMin();
  }
  _isPaginationNextDisabled() {
    return this.page === this.totalNumberPages;
  }
  _isPaginationSliderPreviousDisabled() {
    return this.page === 1;
  }
  _isPaginationSliderNextDisabled() {
    return this.page === this.count;
  }
  get _isRTL() {
    return this._dir?.value === 'rtl';
  }
  static {
    this.ɵfac = function NxPaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPaginationComponent)(i0.ɵɵdirectiveInject(NX_PAGINATION_TEXTS, 8), i0.ɵɵdirectiveInject(i1.Directionality, 8), i0.ɵɵdirectiveInject(NxPaginationUtils), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxPaginationComponent,
      selectors: [["nx-pagination"]],
      viewQuery: function NxPaginationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._linkElements = _t);
        }
      },
      inputs: {
        ariaLabel: "ariaLabel",
        page: "page",
        count: "count",
        perPage: "perPage",
        type: "type"
      },
      outputs: {
        goPrev: "goPrev",
        goNext: "goNext",
        goPage: "goPage"
      },
      decls: 3,
      vars: 3,
      consts: [["link", ""], [1, "nx-pagination"], [1, "nx-pagination-compact"], [1, "nx-pagination-slider"], [1, "nx-pagination__container"], [1, "nx-pagination__item"], ["type", "button", 1, "nx-pagination__link", "nx-pagination__link--first", 3, "click", "disabled"], ["aria-hidden", "true", 1, "nx-pagination__arrow", 3, "name"], [1, "nx-pagination__item", "nx-pagination__item-previous"], ["type", "button", 1, "nx-pagination__link", "nx-pagination__link--previous", 3, "click", "disabled"], [1, "nx-pagination__item", "nx-pagination__item--desktop", 3, "ngClass"], [1, "nx-pagination__item", "nx-pagination__item--mobile", 3, "ngClass"], [1, "nx-pagination__item", "nx-pagination__item-next"], ["type", "button", 1, "nx-pagination__link", "nx-pagination__link--next", 3, "click", "disabled"], ["type", "button", 1, "nx-pagination__link", "nx-pagination__link--last", 3, "click", "disabled"], ["type", "button", 1, "nx-pagination--number", 3, "ngClass"], ["type", "button", 1, "nx-pagination--number", 3, "click", "ngClass"], ["type", "button", 1, "nx-pagination-compact__previous", 3, "click", "disabled"], [1, "nx-pagination-compact__direction-label"], [1, "nx-pagination-compact__display"], [1, "nx-pagination-compact__current-page"], [1, "nx-pagination-compact__page-separator"], [1, "nx-pagination-compact__total-pages"], ["type", "button", 1, "nx-pagination-compact__next", 3, "click", "disabled"], ["type", "button", 1, "nx-pagination--icon", 3, "click"]],
      template: function NxPaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NxPaginationComponent_Conditional_0_Template, 22, 21, "nav", 1)(1, NxPaginationComponent_Conditional_1_Template, 18, 16, "nav", 2)(2, NxPaginationComponent_Conditional_2_Template, 12, 11, "nav", 3);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.isPaginationVisible() && ctx.isPaginationContainerVisible() ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isPaginationCompactVisible() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isPaginationSliderVisible() ? 2 : -1);
        }
      },
      dependencies: [NxIconModule, i4.NxIconComponent, NgClass],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   button[_ngcontent-%COMP%]::-moz-focus-inner{border:0}.nx-pagination__container[_ngcontent-%COMP%]{display:flex;font-size:var(--pagination-font-size);line-height:var(--pagination-line-height);font-weight:var(--pagination-font-weight);letter-spacing:var(--pagination-letter-spacing);padding:0}.nx-pagination__item[_ngcontent-%COMP%]{margin:0 16px;list-style:none;font-weight:var(--pagination-item-font-weight)}.nx-pagination__item[_ngcontent-%COMP%]:first-child{margin:0}.nx-pagination__item[_ngcontent-%COMP%]:last-child{margin:0}.nx-pagination__item.is-ellipsis[_ngcontent-%COMP%]{color:var(--pagination-text-color)}.nx-pagination__item--expanded-view[_ngcontent-%COMP%]{display:block}.nx-pagination__link[_ngcontent-%COMP%]{color:var(--pagination-link-color);padding:0;text-decoration:none;background-color:transparent;border:0;cursor:pointer;font:inherit}.nx-pagination__link.is-active[_ngcontent-%COMP%]{color:var(--pagination-text-color);font-weight:700}@media screen and (forced-colors: active){.nx-pagination__link.is-active[_ngcontent-%COMP%]{border-bottom:4px solid CanvasText}}nx-icon.nx-pagination__arrow[_ngcontent-%COMP%]{font-size:var(--pagination-icon-size)}.nx-pagination-compact[_ngcontent-%COMP%]{display:flex;font-size:var(--pagination-font-size);line-height:var(--pagination-line-height);font-weight:var(--pagination-font-weight);letter-spacing:var(--pagination-letter-spacing);padding:0}.nx-pagination-compact__display[_ngcontent-%COMP%]{color:var(--pagination-text-color);display:flex}.nx-pagination-compact__current-page[_ngcontent-%COMP%]{font-weight:700;margin-right:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__current-page[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__current-page[_ngcontent-%COMP%]{margin-right:initial;margin-left:8px}.nx-pagination-compact__total-pages[_ngcontent-%COMP%]{margin-left:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__total-pages[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__total-pages[_ngcontent-%COMP%]{margin-right:8px;margin-left:initial}.nx-pagination-compact__next[_ngcontent-%COMP%], .nx-pagination-compact__previous[_ngcontent-%COMP%], .nx-pagination__arrow-last[_ngcontent-%COMP%], .nx-pagination__arrow-first[_ngcontent-%COMP%]{color:var(--pagination-link-color);font-weight:var(--pagination-icon-font-weight);text-decoration:none;text-transform:uppercase;display:flex;align-items:center;padding:0;background-color:transparent;cursor:pointer;border:0}.nx-pagination-compact__previous[_ngcontent-%COMP%]{margin-right:32px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__previous[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__previous[_ngcontent-%COMP%]{margin-right:initial;margin-left:32px}.nx-pagination-compact__next[_ngcontent-%COMP%]{margin-left:32px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__next[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__next[_ngcontent-%COMP%]{margin-right:32px;margin-left:initial}.nx-pagination-compact__direction-label[_ngcontent-%COMP%]{display:block;font-size:var(--pagination-compact-direction-font-size);line-height:var(--pagination-compact-direction-line-height);font-weight:var(--pagination-compact-direction-font-weight);letter-spacing:var(--pagination-compact-direction-letter-spacing)}.nx-pagination-compact__direction-label[_ngcontent-%COMP%]:first-child{margin-right:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__direction-label[_ngcontent-%COMP%]:first-child, [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__direction-label[_ngcontent-%COMP%]:first-child{margin-right:initial;margin-left:8px}.nx-pagination-compact__direction-label[_ngcontent-%COMP%]:last-child{margin-left:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination-compact__direction-label[_ngcontent-%COMP%]:last-child, [dir=rtl]   [_nghost-%COMP%]   .nx-pagination-compact__direction-label[_ngcontent-%COMP%]:last-child{margin-right:8px;margin-left:initial}.nx-pagination-compact__previous.is-disabled[_ngcontent-%COMP%], .nx-pagination-compact__next.is-disabled[_ngcontent-%COMP%], .nx-pagination__link.is-disabled[_ngcontent-%COMP%]{color:var(--pagination-link-disabled-color);cursor:not-allowed}@media screen and (forced-colors: active){.nx-pagination-compact__previous.is-disabled[_ngcontent-%COMP%], .nx-pagination-compact__next.is-disabled[_ngcontent-%COMP%], .nx-pagination__link.is-disabled[_ngcontent-%COMP%]{color:GrayText}}.nx-pagination-compact__previous.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination-compact__next.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination__link.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination--icon.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination--number.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-pagination-compact__previous.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination-compact__next.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination__link.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination--icon.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-pagination--number.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-pagination__link--next[_ngcontent-%COMP%], .nx-pagination__link--previous[_ngcontent-%COMP%], .nx-pagination__link--first[_ngcontent-%COMP%], .nx-pagination__link--last[_ngcontent-%COMP%]{display:flex;align-items:center}.nx-pagination__item-next[_ngcontent-%COMP%]{margin-right:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination__item-next[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination__item-next[_ngcontent-%COMP%]{margin-right:initial;margin-left:8px}.nx-pagination__item-previous[_ngcontent-%COMP%]{margin-left:8px}[dir=rtl][_nghost-%COMP%]   .nx-pagination__item-previous[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-pagination__item-previous[_ngcontent-%COMP%]{margin-right:8px;margin-left:initial}.nx-pagination-compact__direction-label[_ngcontent-%COMP%], .nx-pagination__link--first[_ngcontent-%COMP%], .nx-pagination__link--last[_ngcontent-%COMP%], .nx-pagination__item--desktop[_ngcontent-%COMP%]{display:flex}@container (max-width: 703px){.nx-pagination-compact__direction-label[_ngcontent-%COMP%], .nx-pagination__link--first[_ngcontent-%COMP%], .nx-pagination__link--last[_ngcontent-%COMP%], .nx-pagination__item--desktop[_ngcontent-%COMP%]{display:none}}@media (max-width: 703px){.nx-pagination-compact__direction-label[_ngcontent-%COMP%], .nx-pagination__link--first[_ngcontent-%COMP%], .nx-pagination__link--last[_ngcontent-%COMP%], .nx-pagination__item--desktop[_ngcontent-%COMP%]{display:none}}.nx-pagination__item--mobile[_ngcontent-%COMP%]{display:none}@container (max-width: 703px){.nx-pagination__item--mobile[_ngcontent-%COMP%]{display:block}}@media (max-width: 703px){.nx-pagination__item--mobile[_ngcontent-%COMP%]{display:block}}.nx-pagination-slider[_ngcontent-%COMP%]   .nx-pagination__item[_ngcontent-%COMP%]{display:flex;align-items:center;margin:0 16px}.nx-pagination-slider[_ngcontent-%COMP%]   .nx-pagination--icon[_ngcontent-%COMP%]{width:var(--pagination-slider-icon-width);height:var(--pagination-slider-icon-height);border:1px solid var(--pagination-slider-icon-border-color);border-radius:50%;padding:0;background:none;cursor:pointer}.nx-pagination-slider[_ngcontent-%COMP%]   .nx-pagination--icon.is-active[_ngcontent-%COMP%]{background-color:var(--pagination-slider-icon-active-color);cursor:auto}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPaginationComponent, [{
    type: Component,
    args: [{
      selector: 'nx-pagination',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxIconModule, NgClass],
      template: "@if (isPaginationVisible() && isPaginationContainerVisible()) {\n    <nav [attr.aria-label]=\"ariaLabel\" class=\"nx-pagination\">\n        <ul class=\"nx-pagination__container\">\n            <li class=\"nx-pagination__item\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationPreviousDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.first\"\n                    [class.is-disabled]=\"_isPaginationPreviousDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--first\"\n                    (click)=\"onFirst()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-last' : 'arrow-first'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n            <li class=\"nx-pagination__item nx-pagination__item-previous\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationPreviousDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.previous\"\n                    [class.is-disabled]=\"_isPaginationPreviousDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--previous\"\n                    (click)=\"onPrev()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-right' : 'arrow-left'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n            @for (pageNum of getPages(); track pageNum.value) {\n                <li class=\"nx-pagination__item nx-pagination__item--desktop\" [ngClass]=\"getPaginationItemClasses(pageNum)\">\n                    @if (pageNum.label !== '...') {\n                        <button\n                            #link\n                            class=\"nx-pagination--number\"\n                            (click)=\"onPage(pageNum.value)\"\n                            [attr.aria-current]=\"pageNum.value === page ? 'page' : ''\"\n                            [ngClass]=\"getPaginationNumberClasses(pageNum)\"\n                            type=\"button\"\n                        >\n                            {{ pageNum.label }}\n                        </button>\n                    }\n                    @if (pageNum.label === '...') {\n                        <span>\n                            {{ pageNum.label }}\n                        </span>\n                    }\n                </li>\n            }\n            @for (pageNum of getMobilePages(); track pageNum.value) {\n                <li class=\"nx-pagination__item nx-pagination__item--mobile\" [ngClass]=\"getPaginationItemClasses(pageNum)\">\n                    <button\n                        #link\n                        class=\"nx-pagination--number\"\n                        (click)=\"onPage(pageNum.value)\"\n                        [attr.aria-current]=\"pageNum.value === page ? 'page' : ''\"\n                        [ngClass]=\"getPaginationNumberClasses(pageNum)\"\n                        type=\"button\"\n                    >\n                        {{ pageNum.label }}\n                    </button>\n                </li>\n            }\n            <li class=\"nx-pagination__item nx-pagination__item-next\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationNextDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.next\"\n                    [class.is-disabled]=\"_isPaginationNextDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--next\"\n                    (click)=\"onNext()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-left' : 'arrow-right'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n            <li class=\"nx-pagination__item\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationNextDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.last\"\n                    [class.is-disabled]=\"_isPaginationNextDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--last\"\n                    (click)=\"onLast()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-first' : 'arrow-last'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n        </ul>\n    </nav>\n}\n@if (isPaginationCompactVisible()) {\n    <nav [attr.aria-label]=\"ariaLabel\" class=\"nx-pagination-compact\">\n        <button\n            #link\n            [attr.aria-label]=\"paginationTexts.previous\"\n            class=\"nx-pagination-compact__previous\"\n            [disabled]=\"_isPaginationPreviousDisabled()\"\n            [class.is-disabled]=\"_isPaginationPreviousDisabled()\"\n            (click)=\"onPrev()\"\n            type=\"button\"\n        >\n            <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-right' : 'arrow-left'\" aria-hidden=\"true\"></nx-icon>\n            <span class=\"nx-pagination-compact__direction-label\">\n                {{ paginationTexts.previous }}\n            </span>\n        </button>\n        <div class=\"nx-pagination-compact__display\">\n            <span class=\"nx-pagination-compact__current-page\">{{ page }}</span>\n            <span class=\"nx-pagination-compact__page-separator\"> {{ paginationTexts.ofLabel }} </span>\n            <span class=\"nx-pagination-compact__total-pages\">{{ totalNumberPages }}</span>\n        </div>\n        <button\n            #link\n            class=\"nx-pagination-compact__next\"\n            [disabled]=\"_isPaginationNextDisabled()\"\n            [class.is-disabled]=\"_isPaginationNextDisabled()\"\n            [attr.aria-label]=\"paginationTexts.next\"\n            (click)=\"onNext()\"\n            type=\"button\"\n        >\n            <span class=\"nx-pagination-compact__direction-label\"> {{ paginationTexts.next }} </span>\n            <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-left' : 'arrow-right'\" aria-hidden=\"true\"></nx-icon>\n        </button>\n    </nav>\n}\n@if (isPaginationSliderVisible()) {\n    <nav [attr.aria-label]=\"ariaLabel\" class=\"nx-pagination-slider\">\n        <ul class=\"nx-pagination__container\">\n            <li class=\"nx-pagination__item nx-pagination__item-previous\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationSliderPreviousDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.previous\"\n                    [class.is-disabled]=\"_isPaginationSliderPreviousDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--previous\"\n                    (click)=\"onPrev()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-right' : 'arrow-left'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n            @for (pageNum of getSlides(); track pageNum.value) {\n                <li class=\"nx-pagination__item\">\n                    <button\n                        #link\n                        class=\"nx-pagination--icon\"\n                        (click)=\"onPage(pageNum.value)\"\n                        [attr.aria-label]=\"pageNum.value\"\n                        [attr.aria-current]=\"pageNum.value === page ? 'page' : ''\"\n                        [class.is-active]=\"pageNum.value === page\"\n                        type=\"button\"\n                    ></button>\n                </li>\n            }\n            <li class=\"nx-pagination__item nx-pagination__item-next\">\n                <button\n                    #link\n                    [disabled]=\"_isPaginationSliderNextDisabled()\"\n                    [attr.aria-label]=\"paginationTexts.next\"\n                    [class.is-disabled]=\"_isPaginationSliderNextDisabled()\"\n                    class=\"nx-pagination__link nx-pagination__link--next\"\n                    (click)=\"onNext()\"\n                    type=\"button\"\n                >\n                    <nx-icon class=\"nx-pagination__arrow\" [name]=\"_isRTL ? 'arrow-left' : 'arrow-right'\" aria-hidden=\"true\"></nx-icon>\n                </button>\n            </li>\n        </ul>\n    </nav>\n}\n",
      styles: [":host{display:block}:host button:focus{outline:none}:host button::-moz-focus-inner{border:0}.nx-pagination__container{display:flex;font-size:var(--pagination-font-size);line-height:var(--pagination-line-height);font-weight:var(--pagination-font-weight);letter-spacing:var(--pagination-letter-spacing);padding:0}.nx-pagination__item{margin:0 16px;list-style:none;font-weight:var(--pagination-item-font-weight)}.nx-pagination__item:first-child{margin:0}.nx-pagination__item:last-child{margin:0}.nx-pagination__item.is-ellipsis{color:var(--pagination-text-color)}.nx-pagination__item--expanded-view{display:block}.nx-pagination__link{color:var(--pagination-link-color);padding:0;text-decoration:none;background-color:transparent;border:0;cursor:pointer;font:inherit}.nx-pagination__link.is-active{color:var(--pagination-text-color);font-weight:700}@media screen and (forced-colors: active){.nx-pagination__link.is-active{border-bottom:4px solid CanvasText}}nx-icon.nx-pagination__arrow{font-size:var(--pagination-icon-size)}.nx-pagination-compact{display:flex;font-size:var(--pagination-font-size);line-height:var(--pagination-line-height);font-weight:var(--pagination-font-weight);letter-spacing:var(--pagination-letter-spacing);padding:0}.nx-pagination-compact__display{color:var(--pagination-text-color);display:flex}.nx-pagination-compact__current-page{font-weight:700;margin-right:8px}:host-context([dir=rtl]) .nx-pagination-compact__current-page{margin-right:initial;margin-left:8px}.nx-pagination-compact__total-pages{margin-left:8px}:host-context([dir=rtl]) .nx-pagination-compact__total-pages{margin-right:8px;margin-left:initial}.nx-pagination-compact__next,.nx-pagination-compact__previous,.nx-pagination__arrow-last,.nx-pagination__arrow-first{color:var(--pagination-link-color);font-weight:var(--pagination-icon-font-weight);text-decoration:none;text-transform:uppercase;display:flex;align-items:center;padding:0;background-color:transparent;cursor:pointer;border:0}.nx-pagination-compact__previous{margin-right:32px}:host-context([dir=rtl]) .nx-pagination-compact__previous{margin-right:initial;margin-left:32px}.nx-pagination-compact__next{margin-left:32px}:host-context([dir=rtl]) .nx-pagination-compact__next{margin-right:32px;margin-left:initial}.nx-pagination-compact__direction-label{display:block;font-size:var(--pagination-compact-direction-font-size);line-height:var(--pagination-compact-direction-line-height);font-weight:var(--pagination-compact-direction-font-weight);letter-spacing:var(--pagination-compact-direction-letter-spacing)}.nx-pagination-compact__direction-label:first-child{margin-right:8px}:host-context([dir=rtl]) .nx-pagination-compact__direction-label:first-child{margin-right:initial;margin-left:8px}.nx-pagination-compact__direction-label:last-child{margin-left:8px}:host-context([dir=rtl]) .nx-pagination-compact__direction-label:last-child{margin-right:8px;margin-left:initial}.nx-pagination-compact__previous.is-disabled,.nx-pagination-compact__next.is-disabled,.nx-pagination__link.is-disabled{color:var(--pagination-link-disabled-color);cursor:not-allowed}@media screen and (forced-colors: active){.nx-pagination-compact__previous.is-disabled,.nx-pagination-compact__next.is-disabled,.nx-pagination__link.is-disabled{color:GrayText}}.nx-pagination-compact__previous.cdk-keyboard-focused,.nx-pagination-compact__next.cdk-keyboard-focused,.nx-pagination__link.cdk-keyboard-focused,.nx-pagination--icon.cdk-keyboard-focused,.nx-pagination--number.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-pagination-compact__previous.cdk-keyboard-focused,.nx-pagination-compact__next.cdk-keyboard-focused,.nx-pagination__link.cdk-keyboard-focused,.nx-pagination--icon.cdk-keyboard-focused,.nx-pagination--number.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-pagination__link--next,.nx-pagination__link--previous,.nx-pagination__link--first,.nx-pagination__link--last{display:flex;align-items:center}.nx-pagination__item-next{margin-right:8px}:host-context([dir=rtl]) .nx-pagination__item-next{margin-right:initial;margin-left:8px}.nx-pagination__item-previous{margin-left:8px}:host-context([dir=rtl]) .nx-pagination__item-previous{margin-right:8px;margin-left:initial}.nx-pagination-compact__direction-label,.nx-pagination__link--first,.nx-pagination__link--last,.nx-pagination__item--desktop{display:flex}@container (max-width: 703px){.nx-pagination-compact__direction-label,.nx-pagination__link--first,.nx-pagination__link--last,.nx-pagination__item--desktop{display:none}}@media (max-width: 703px){.nx-pagination-compact__direction-label,.nx-pagination__link--first,.nx-pagination__link--last,.nx-pagination__item--desktop{display:none}}.nx-pagination__item--mobile{display:none}@container (max-width: 703px){.nx-pagination__item--mobile{display:block}}@media (max-width: 703px){.nx-pagination__item--mobile{display:block}}.nx-pagination-slider .nx-pagination__item{display:flex;align-items:center;margin:0 16px}.nx-pagination-slider .nx-pagination--icon{width:var(--pagination-slider-icon-width);height:var(--pagination-slider-icon-height);border:1px solid var(--pagination-slider-icon-border-color);border-radius:50%;padding:0;background:none;cursor:pointer}.nx-pagination-slider .nx-pagination--icon.is-active{background-color:var(--pagination-slider-icon-active-color);cursor:auto}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_PAGINATION_TEXTS]
    }]
  }, {
    type: i1.Directionality,
    decorators: [{
      type: Optional
    }]
  }, {
    type: NxPaginationUtils
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i3.FocusMonitor
  }], {
    _linkElements: [{
      type: ViewChildren,
      args: ['link']
    }],
    ariaLabel: [{
      type: Input
    }],
    page: [{
      type: Input
    }],
    count: [{
      type: Input
    }],
    perPage: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    goPrev: [{
      type: Output
    }],
    goNext: [{
      type: Output
    }],
    goPage: [{
      type: Output
    }]
  });
})();
class NxPaginationModule {
  static {
    this.ɵfac = function NxPaginationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPaginationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxPaginationModule,
      imports: [CommonModule, NxIconModule, NxPaginationComponent],
      exports: [NxPaginationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NxIconModule, NxPaginationComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPaginationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NxIconModule, NxPaginationComponent],
      exports: [NxPaginationComponent],
      providers: []
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultPaginationTexts, NX_PAGINATION_TEXTS, NxPaginationComponent, NxPaginationModule, NxPaginationUtils };
